// extracted by mini-css-extract-plugin
export default {"footerContainer":"S1ypm","headerMenuList":"TOjGr","headerListItem":"TO2Dy","depositLink":"Kp6DP","infoBlock":"PcYfq","infoBlockWithLicense":"Fm00m","informationContainer":"nxM9V"};